import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import Select from "../../../../../components/Select"

import "./promoted-category-header.styles.scss"

/**
 * Read-only header for a promoted category (N1). Fields are visible but
 * disabled — the category inherits name/category/language/country from the
 * promoted niche and its parent topic. A chip links back to the parent topic.
 */
export const PromotedCategoryHeader = ({
  name,
  categoryTitle,
  languageLabel,
  countryLabel,
  promotedFrom
}) => {
  return (
    <div className="TopicEditHeader PromotedCategoryHeader">
      <div className="top">
        <div className="inputs">
          <Select value={{ label: name }} label="Category name" isDisabled />
          <Select
            value={{ label: categoryTitle }}
            label="Category"
            isDisabled
          />
          <Select
            value={{ label: languageLabel }}
            label="Language"
            isDisabled
          />
          {countryLabel && (
            <Select
              value={{ label: countryLabel }}
              label="Country"
              isDisabled
            />
          )}
        </div>

        {promotedFrom &&
          (promotedFrom.parentTopicId ? (
            <Link
              to={`/topics/edit/${promotedFrom.parentTopicId}`}
              target="_blank"
              rel="noopener noreferrer"
              className="promoted-origin-chip"
              title={`Open ${promotedFrom.parentTopicName} in a new tab`}
            >
              Promoted from &ldquo;{promotedFrom.nicheName}&rdquo; in{" "}
              {promotedFrom.parentTopicName}
            </Link>
          ) : (
            <div className="promoted-origin-chip">
              Promoted from &ldquo;{promotedFrom.nicheName}&rdquo; in{" "}
              {promotedFrom.parentTopicName}
            </div>
          ))}
      </div>
    </div>
  )
}

PromotedCategoryHeader.propTypes = {
  name: PropTypes.string.isRequired,
  categoryTitle: PropTypes.string,
  languageLabel: PropTypes.string,
  countryLabel: PropTypes.string,
  promotedFrom: PropTypes.shape({
    nicheName: PropTypes.string,
    parentTopicName: PropTypes.string,
    parentTopicId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
}
